export default {
  radioSizeSmall: '14px',
  radioSizeMedium: '16px',
  radioSizeLarge: '18px',
  labelPadding: '0 8px',
  labelFontWeight: '400'
}
